import styled from "styled-components";

export const ButtonsContainer = styled.div<{ isSubWalletsAvailable?: boolean }>`
  padding: ${({ isSubWalletsAvailable }) =>
      isSubWalletsAvailable ? "0" : "32px"}
    10px 22px 10px;
  display: flex;
  justify-content: space-between;
`;
